import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const clearSearchedGlobalSectionItems = () => (dispatch) => {
    dispatch({
        type: ACTIONS.CLEAR_SEARCHED_GLOBAL_SECTION_ITEMS
    });
};

/**
 *
 * @param {Object} params
 * @param {String} actionType
 * @return {function(*)}
 * @private
 */
const _getManyGlobalSectionItems = (params, actionType) => {
    const { pathsContext, ...rest } = params;
    const baseUrl = `${pathsContext.adminServerUrl}/globalsectionitems`;
    const url = buildQueryString(rest, baseUrl);

    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: actionType,
                payload: {
                    globalSectionItems: body
                }
            });
            return body;
        });
};

/**
 *
 * @param {Object} query
 * @return {function(*)}
 */
export const getFilteredGlobalSectionItems = (query) =>
    _getManyGlobalSectionItems(query, ACTIONS.GET_FILTERED_GLOBAL_SECTION_ITEMS);

/**
 *
 * @param {Object} params
 * @return {function(*)}
 */
export const getManyGlobalSectionItems = (params) =>
    _getManyGlobalSectionItems(params, ACTIONS.GET_MANY_GLOBAL_SECTION_ITEMS);

export const getGlobalSectionItem = (params, query = {}) => {
    const { globalSectionItemId, pathsContext } = params;

    return (dispatch) => {
        const baseUrl = `${pathsContext.adminServerUrl}/globalsectionitems/${globalSectionItemId}`;
        const url = buildQueryString(query, baseUrl);
        return VerbFetch(url).then((globalSectionItemBody) => {
            dispatch({
                type: ACTIONS.GET_GLOBAL_SECTION_ITEM,
                payload: {
                    globalSectionItem: globalSectionItemBody
                }
            });

            return globalSectionItemBody;
        });
    };
};

export const postGlobalSectionItem = (params) => {
    const { body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.POST_GLOBAL_SECTION_ITEM_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/globalsectionitems`, {
            method: 'POST',
            body
        }).then((result) => {
            dispatch({
                type: ACTIONS.POST_GLOBAL_SECTION_ITEM_SUCCESS,
                payload: {
                    globalSectionItem: result
                }
            });

            return result;
        });
    };
};

export const putGlobalSectionItem = (params) => {
    const { globalSectionItemId, body, pathsContext } = params;
    return (dispatch) => {
        dispatch({
            type: ACTIONS.PUT_GLOBAL_SECTION_ITEM_START,
            payload: {
                body
            }
        });
        return VerbFetch(`${pathsContext.adminServerUrl}/globalsectionitems/${globalSectionItemId}`, {
            method: 'PUT',
            body
        }).then((result) => {
            dispatch({
                type: ACTIONS.PUT_GLOBAL_SECTION_ITEM_SUCCESS,
                payload: {
                    globalSectionItem: result
                }
            });

            return result;
        });
    };
};
